import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import UserHeader from "components/Headers/UserHeader.js";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";

const CreaRepresentante = () => {
  const [postVariable, setPostVariable] = useState(null);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback.azurewebsites.net/api/v1/ObtenerUsuarios",
    })
      .then((Response) => {
        const apiOptions = Response.data.map((item) => ({
          value: item.id,
          label: item.nombre,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire("Error", "No se pudo cargar la lista de usuarios.", "error");
      });
  }, []);

  const crearRepresentante = async (e) => {
    e.preventDefault();

    if (!postVariable || !postVariable.value) {
      Swal.fire("Campo requerido", "Seleccione un representante.", "warning");
      return;
    }

    const payload = {
      idUsuario: postVariable.value,
    };

    setLoading(true);
    try {
      Swal.fire({
        title: "Guardando...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.post(
        `https://contratosback.azurewebsites.net/api/v1/CreaAprobadorLegal/${postVariable.value}`,
        payload, // 👈 aquí va el body
      );

      Swal.fire("¡Éxito!", response.data, "success");
      closeModal();
    } catch (error) {
      console.error("Error:", error);

      if (error.response?.status === 409) {
        Swal.fire("Advertencia", "El representante ya existe.", "warning");
      } else {
        Swal.fire(
          "Error",
          "Hubo un problema al crear el representante.",
          "error",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-primary btn-lg" onClick={handleOpenModalTest}>
        Nuevo
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Representante"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={crearRepresentante}>
                    <h6 className="heading-small text-muted mb-4">
                      Seleccione el Representante
                    </h6>

                    <div className="pl-lg-4">
                      <FormGroup>
                        <Select
                          name="representante"
                          options={options}
                          classNamePrefix="select"
                          onChange={setPostVariable}
                          isDisabled={isLoading}
                        />
                      </FormGroup>

                      <hr />

                      <button
                        type="submit"
                        className="btn btn-primary btn-user btn-block"
                        disabled={isLoading}
                      >
                        {isLoading ? <Spinner size="sm" /> : "Guardar"}
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CreaRepresentante;
